import React from 'react';
import { Card, Button } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import blockedCountriesImg from './assets/blocked_countries.svg';
import './JurisdictionBlocked.scss';
import Translate from '../../../../../../../i18n/Translate';

const JurisdictionBlocked = () => {
  const history = useHistory();

  return (
    <Card className="jurisdictionBlocked p-3 p-xl-4 border-0 box-shadow">
      <p className="jurisdictionBlocked__title font-20">
        <Translate translationKey="Texts.jurisdiction-blocked.investment-not-available-in-country-title" />
      </p>
      <img
        className="jurisdictionBlocked__img"
        alt=""
        src={blockedCountriesImg}
      />
      <p className="jurisdictionBlocked__description font-16">
        <Translate translationKey="Texts.jurisdiction-blocked.investment-not-available-in-country-description" />
      </p>
      <Button
        id="btn-jurisdiction-blocked--leave"
        className="m-0 issuer-button-primary"
        block
        size="lg"
        onClick={() => history.push('/opportunities')}
      >
        <Translate translationKey="Texts.jurisdiction-blocked.see-other-opportunities" />
      </Button>
    </Card>
  );
};

export default JurisdictionBlocked;
